import { createRouter, createWebHistory } from 'vue-router';
import store from '@/plugins/store.js';

import LoginView from '@/views/LoginView.vue';
import ForgotPasswordView from '@/views/ForgotPasswordView.vue';
import SetPasswordView from '@/views/SetPasswordView.vue';
import SelectClientView from '@/views/SelectClientView.vue';
import HomeView from '@/views/HomeView.vue';
import CalendarView from '@/views/CalendarView.vue';
import MySessionsView from '@/views/MySessionsView.vue';
import ProfileView from '@/views/ProfileView.vue';

const routes = [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/forgot-password', name: 'forgot-password', component: ForgotPasswordView, meta: { public: true } },
    { path: '/set-password/:token', name: 'set-password', component: SetPasswordView, meta: { public: true } },
    { path: '/select-client', name: 'select-client', component: SelectClientView },
    // The landing screen: sports-center info + statistics, reachable from the nav menu alongside the calendar.
    { path: '/home', name: 'home', component: HomeView, meta: { chrome: true, client: true } },
    { path: '/calendar', name: 'calendar', component: CalendarView, meta: { chrome: true, client: true } },
    { path: '/my-sessions', name: 'my-sessions', component: MySessionsView, meta: { chrome: true, client: true } },
    { path: '/profile', name: 'profile', component: ProfileView, meta: { chrome: true, client: true } },
    { path: '/', redirect: { name: 'home' } },
    { path: '/:pathMatch(.*)*', redirect: { name: 'home' } }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to) => {
    const authed = store.getters.isAuthenticated;

    if (to.meta.public) {
        // Already logged in users have no business on the login screen.
        if (authed && to.name === 'login') return { name: 'home' };
        return true;
    }

    if (!authed) return { name: 'login' };

    // Routes that operate inside a client require one to be selected.
    if (to.meta.client && store.getters.selectedClient === null) {
        return { name: 'select-client' };
    }

    // Nothing to select into.
    if (to.name === 'select-client' && store.state.clients.length === 0) {
        return true;
    }

    return true;
});

export default router;
